import React from 'react';

import { SettingsChangePasswordForm, SettingsUserInfo, PrivateLayout, ResourceContent } from '../components';
import { NotificationSettings } from '../components/NotificationSettings';
import { AnyType } from '../interfaces';
import { useSelector } from 'react-redux';
import { tenancyFeatureSelector } from '../redux/selectors';
import { getConfigurationDataKey } from '../utils';
import { Col, Row } from 'react-bootstrap';

export const SettingsView = () => {
  const enableNotification: AnyType = useSelector<AnyType>(tenancyFeatureSelector('enable-notification'));

  return (
    <PrivateLayout
      pageTitle='my account'
      className='px-4'
      pageIcon={<i className='fa-light fa-user-gear'></i>}
      subtoolbarChildren={
        <Row>
          <Col>
            <p className='required-text float-end general-note mb-2'>
              <ResourceContent contentKey={getConfigurationDataKey('general.required-fields-note')} />
            </p>
          </Col>
        </Row>
      }>
      <div className='mt-4'>
        <SettingsUserInfo />
      </div>
      <div className='mt-4'>
        <span>
          To change your password, enter your existing password for verification. Then, enter your new password and
          confirm the new password. Change your password by selecting the Change Password button.
        </span>
      </div>
      <div className='mt-4'>
        <SettingsChangePasswordForm />
      </div>
      {enableNotification?.enabled && (
        <>
          <hr />
          <div className='w-75'>
            <NotificationSettings />
          </div>
        </>
      )}
    </PrivateLayout>
  );
};
